export default __webpack_public_path__ + "static/media/backgroundmobile.7def68af.png";